import { render, staticRenderFns } from "./transSignLinkedAccPropSmsCustFields.vue?vue&type=template&id=3155155e"
import script from "./transSignLinkedAccPropSmsCustFields.ts?vue&type=script&lang=js&external"
export * from "./transSignLinkedAccPropSmsCustFields.ts?vue&type=script&lang=js&external"
import style0 from "../customerDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports